import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const QuizAppReact = () => {
  useEffect(() => {
    document.title = "Quiz App — Viktoriia Yashkina";
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.75, ease: "easeOut" }}
      className="body"
    >
      <div className="portfolioContainer">
        <div className="pt-12">
          <Link to="/portfolio" className="backLink">
            Back
          </Link>
          <h2 className="h2PortfolioProject">portfolio — quiz App</h2>{" "}
          <div className="portfolioContext">
            <div className="textContainer">
              <p>
                Since my coding learning is too slow (I was taking on too much),
                I arranged a personal coding marathon for a whole week. The main
                goal - do one project per day from 28.06.2023 to 04.07.2023.
              </p>
              <p>
                This is my seventh and final project in this marathon - Quiz
                App. To create it, I used React and Open Trivia Database API.
                Also, there was Material UI, but I remained dissatisfied with
                the results. I think it's very challenging and isn't worth the
                effort 🤷🏻‍♀️
              </p>
              <p>
                I had to finish this marathon on 04.07, but unfortunately, I got
                sick and managed to finish it only today, on 07.07. But in the
                end, I'm rather pleased with the results of this marathon. Even
                though there weren't any criteria for it, I feel that I have
                become more confident about React and API.{" "}
              </p>
              <p className="font-bold">Technology & Resources Used:</p>
              <p>01. React, HTML5, and CSS3</p>
              <p>02. Material UI</p>
              <p>
                03.{" "}
                <a
                  href="https://opentdb.com/"
                  className="allLinks"
                  rel="noreferrer"
                  target="_blank"
                >
                  Open Trivia Database API
                </a>
              </p>
              <p>04. Vercel for hosting</p>
              <p>05. Google Fonts & Google Icons</p>
              <p className="font-bold">Main Links:</p>
              <p>
                01.{" "}
                <a
                  href="https://quiz-app-react-viktoriia-yash.vercel.app/"
                  className="allLinks"
                  rel="noreferrer"
                  target="_blank"
                >
                  Live Preview
                </a>
              </p>
              <p>
                02.{" "}
                <a
                  href="https://github.com/viktoriia-yash/quiz-app-react"
                  className="allLinks"
                  rel="noreferrer"
                  target="_blank"
                >
                  GitHub
                </a>
              </p>
            </div>
            <div className="max-w-[300px]"></div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default QuizAppReact;
